import { Form } from '@innovationdepartment/proxima-ui';
import AgentView from 'components/Agent/Agent.View';
import { useHandleApi } from 'hooks';
import { useState } from 'react';
import { useBrandStore } from 'stores';
import SectionLayout from 'ui/SectionLayout';

type ChatResponse = {
  messageContent: string;
  vizBase64?: string | null;
};

export type ChatMessage = {
  id: string;
  content: string;
  visBase64?: string | null;
  isUser?: boolean;
};

const ChatWrapper = () => {
  const apiDomain = import.meta.env.VITE_AGENT_API_URL;
  const { handleApi, loading } = useHandleApi({ apiDomain });
  const { brand } = useBrandStore();
  const [messages, setMessages] = useState<ChatMessage[]>([
    {
      id: crypto.randomUUID(),
      content: `Hello ${brand?.name}! How can I assist you today?`,
      isUser: false
    }
  ]);

  const initialValues = { question: '' };

  const handleSend = async ({ question }: { question: string }) => {
    if (!question) return;

    setMessages(prev => [...prev, { id: crypto.randomUUID(), content: question, isUser: true }]);

    const { data } = await handleApi({
      endpoint: `/api/brands/${brand.brandId}/agent`,
      method: 'POST',
      data: {
        brand_id: brand?.brandId,
        question
      }
    });

    const asChatResponse = data as ChatResponse;

    setMessages(prev => [
      ...prev,
      {
        id: crypto.randomUUID(),
        content: asChatResponse.messageContent,
        visBase64: asChatResponse.vizBase64,
        isUser: false
      }
    ]);
  };

  return (
    <SectionLayout title="Proxima Agent">
      <Form onSubmit={handleSend} initialValues={initialValues}>
        <AgentView messages={messages} loading={loading} />
      </Form>
    </SectionLayout>
  );
};

export default ChatWrapper;
